'use client'

import { useCheckout, useModals } from '@/lib/hooks'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { FuturePaymentDate } from '@/components/forms'

interface FuturePaymentDateAndReferenceModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const FuturePaymentDateAndReferenceModal = ({
  open,
}: FuturePaymentDateAndReferenceModalProps) => {
  const { closeModal, closeAll } = useModals()
  const { payment_method } = useCheckout()

  const isReferenceRequired = payment_method?.reference_required === 1
  const isFuturePaymentEnabled = payment_method?.future_payment_enabled === 1

  const getTitle = () => {
    if (isReferenceRequired && isFuturePaymentEnabled) {
      return 'Payment Date and Reference'
    }

    if (isReferenceRequired) {
      return 'Reference'
    }

    if (isFuturePaymentEnabled) {
      return 'Payment Date'
    }

    return 'Information'
  }

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('FUTURE_PAYMENT_DATE_AND_REFERENCE')}
        size="lg"
      >
        <DialogHeader>
          <DialogTitle>{getTitle()}</DialogTitle>
        </DialogHeader>

        {open && <FuturePaymentDate onClose={() => closeAll()} />}
      </DialogContent>
    </Dialog>
  )
}
